import { render, staticRenderFns } from "./ProjectFileExaminationView.vue?vue&type=template&id=ab20f4c6"
import script from "./ProjectFileExaminationView.vue?vue&type=script&lang=ts"
export * from "./ProjectFileExaminationView.vue?vue&type=script&lang=ts"
import style0 from "./ProjectFileExaminationView.vue?vue&type=style&index=0&id=ab20f4c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports